import React, { useContext, useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { ApiContext } from '@api/api.tsx';
import ETransportEmpty from '@components/features/eTransport/ETransportEmpty.tsx';
import ETransportCreate from '@components/features/eTransport/ETransportCreate.tsx';
import ETransportDetail from '@components/features/eTransport/ETransportDetail.tsx';
import { ETransportDTO } from '@api/ringil-api.v2.tsx';
import { SecuredConfig, useSecuredDecoration } from '@components/security/securedDecoration';

interface ComponentProps {
  reservationId: string;
  applicationId: string;
  readonly?: boolean;
  secured?: SecuredConfig;
}

const ETransport: React.FC<ComponentProps> = ({ reservationId, applicationId, readonly, secured }) => {
  const { tr } = useTranslationLgs();
  const { getEtransportDetail } = useContext(ApiContext);
  const [data, setData] = useState<ETransportDTO>();
  const { decorate, editable } = useSecuredDecoration(secured);
  const effectiveReadonly = editable === null ? !!readonly : !editable;

  const [currentView, setCurrentView] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = () => {
    getEtransportDetail(reservationId, data => {
      setData(data);
      if (data) {
        setCurrentView('detail');
      } else {
        setCurrentView('empty');
      }
    });
  };

  const renderView = () => {
    if (currentView === 'create') {
      return (
        <ETransportCreate
          reservationId={reservationId}
          applicationId={applicationId}
          onCompleted={() => load()}
          initialData={{
            referenceNumber: null,
            transportCompany: null,
            licencePlate: null,
            document: null,
            transportDate: null,
            supplierName: '',
            transportMode: 0,
            originAddress: { borderId: null, regionId: null, town: '', street: '' },
            destinationAddress: { borderId: null, regionId: null, town: '', street: '' },
            products: [],
          }}
        />
      );
    }
    if (currentView === 'edit') {
      return <ETransportCreate reservationId={reservationId} onCompleted={() => load()} initialData={data} applicationId={applicationId} />;
    }
    if (currentView === 'detail') {
      return <ETransportDetail detail={data} onEdit={() => setCurrentView('edit')} readOnly={effectiveReadonly} />;
    }
    if (currentView === 'empty') {
      return !effectiveReadonly ? <ETransportEmpty onCreateETransport={() => setCurrentView('create')} /> : null;
    }
    return <>Loading....</>;
  };

  return <>{decorate(renderView())}</>;
};

export default ETransport;
